import { observer } from 'mobx-react-lite'
import { Box, Error, Typography } from 'shared/ui'
import { TimePicker } from 'shared/ui/DatePicker'
import { ToggleChipGroup } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/ui/ToggleChipGroup/ToggleChipGroup'
import type { GoogleCalendarPickerStore } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/googleCalendarPickerStore'
import styles from '../../styles.module.scss'

type IGoogleCalendarAvailabilitySectionProps = {
  googleCalendarPickerStore: GoogleCalendarPickerStore
}

export const GoogleCalendarAvailabilitySection = observer(
  ({ googleCalendarPickerStore }: IGoogleCalendarAvailabilitySectionProps) => {
    const {
      availabilityDaysOrder,
      availabilityDays,
      getAvailabilityDayLabel,
      toggleAvailabilityDay,
      availabilityDaysError,
      availabilityFromDate,
      availabilityToDate,
      setAvailabilityFromDate,
      setAvailabilityToDate,
      availabilityTimeError,
      durationOptions,
      durations,
      toggleDuration,
      durationsError,
    } = googleCalendarPickerStore

    return (
      <>
        <div className={styles.sectionWrap}>
          <Typography
            variant={'text-input-label-small'}
            ariaLabel={'AvailabilityLabel'}
            color={'var(--content-primary-secondary)'}
          >
            Availability
          </Typography>
          <ToggleChipGroup
            items={availabilityDaysOrder}
            columns={7}
            isActive={(day) => availabilityDays.has(day)}
            getLabel={getAvailabilityDayLabel}
            onToggle={toggleAvailabilityDay}
          />
          <Error type={'text'} error={availabilityDaysError} />
          <Box display={'flex'} gap={1} marginTop={'12px'}>
            <div className={styles.timePickerWrap}>
              <Typography
                variant={'text-input-label-small'}
                ariaLabel={'FromLabel'}
                color={'var(--content-primary-secondary)'}
              >
                From
              </Typography>
              <TimePicker
                selected={availabilityFromDate}
                onChange={setAvailabilityFromDate}
                textFieldPlaceholderProps={{
                  className: styles.availabilityTimePicker,
                }}
                topListTextFieldProps={{ InputProps: { placeholder: 'From' } }}
              />
            </div>
            <div className={styles.timePickerWrap}>
              <Typography
                variant={'text-input-label-small'}
                ariaLabel={'ToLabel'}
                color={'var(--content-primary-secondary)'}
              >
                To
              </Typography>
              <TimePicker
                selected={availabilityToDate}
                onChange={setAvailabilityToDate}
                textFieldPlaceholderProps={{
                  className: styles.availabilityTimePicker,
                }}
                topListTextFieldProps={{ InputProps: { placeholder: 'To' } }}
              />
            </div>
          </Box>
          <Error type={'text'} error={availabilityTimeError} />
        </div>

        <div className={styles.sectionWrap}>
          <Typography
            variant={'text-input-label-small'}
            ariaLabel={'MeetingDurationLabel'}
            color={'var(--content-primary-secondary)'}
          >
            Meeting duration
          </Typography>
          <ToggleChipGroup
            items={durationOptions}
            columns={4}
            isActive={(minutes) => durations.includes(minutes)}
            getLabel={(minutes) => `${minutes} min`}
            onToggle={toggleDuration}
          />
          <Error type={'text'} error={durationsError} />
        </div>
      </>
    )
  }
)
